var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNycTechWeekSquiggleGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_5557)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_5557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1132
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1132,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_5557)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M-21.8699 812.005C181.55 756.736 210.352 744.968 636.115 662.395C747.67 640.76 721.313 415.554 1140.09 486.704C1538.62 554.413 1295.56 333.472 1140.03 225.749C995.172 125.414 1492.45 3.85088 1677.2 54.7046",
    stroke: "url(#paint0_linear_359_5557)",
    strokeWidth: 5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_5557",
    x1: 390.31,
    y1: 330.064,
    x2: 1383.65,
    y2: 368.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390231,
    stopColor: "#0E97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819851,
    stopColor: "#23C7CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_5557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNycTechWeekSquiggleGraphic);
export default __webpack_public_path__ + "static/media/nyc-tech-week-squiggle-graphic.5134a1db87d2a3a403ea24a65f101a87.svg";
export { ForwardRef as ReactComponent };